import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import className from 'classnames'
import scrollToElement from 'scroll-to-element'

import GenericNameField from 'components/form/GenericNameField'
import EmailField from 'components/form/EmailField'
import QantasFrequentFlyerNumberField from 'components/form/QantasFrequentFlyerNumberField'
import BrandedButton from 'components/BrandedButton'
import {
  QFF_FIRST_NAME_KEY,
  QFF_LAST_NAME_KEY,
  QFF_EMAIL_KEY,
  QFF_REFERENCE_KEY,
  QFF_NUMBER_KEY,
  QFF_SUCCESS_CONTAINER_ID,
} from 'containers/QantasFrequentFlyer/constants'

import styles from './styles.scss'

export default class QantasFrequentFlyerDetailed extends PureComponent {
  render() {
    const {
      qffReducer,
      fieldError,
      firstNameLabel,
      lastNameLabel,
      emailLabel,
      referenceLabel,
      qffLabel,
      submitLabel,
      termsText,
      successText,
      onSubmit,
      onFieldChangeHandler,
      onFieldBlur,
      clearEmailErrors,
      fieldValues,
      isFormComplete,
    } = this.props
    const { isLoading, success, message } = qffReducer

    const isFormCompleteClass = isFormComplete ? styles.form_complete : ''

    const responseMessageElement = message && !success && Object.keys(fieldError).length === 0
      ? <p className={styles.form_error}>{message}</p>
      : null
    const termsConditionsElement = !termsText ? null : (
      // eslint-disable-next-line react/no-danger
      <div className={styles.terms} dangerouslySetInnerHTML={{ __html: termsText }} />
    )

    if (success) {
      scrollToElement(document.getElementById(QFF_SUCCESS_CONTAINER_ID), {
        offset: -100,
        ease: 'linear',
        duration: 250,
      })
    }

    return (
      <form
        className={className(styles.container, isFormCompleteClass)}
        onSubmit={onSubmit}
        method="POST"
      >
        <fieldset className={styles.form_container}>
          <legend>Start earning Qantas Points</legend>
          <div className={className(styles.field, styles.field_name)}>
            <GenericNameField
              labelText={firstNameLabel}
              fieldName={QFF_FIRST_NAME_KEY}
              onChange={onFieldChangeHandler}
              onBlur={onFieldBlur}
              value={fieldValues[QFF_FIRST_NAME_KEY]}
              errorMessage={fieldError[QFF_FIRST_NAME_KEY]}
              loading={isLoading}
              isRequired
            />
          </div>
          <div className={className(styles.field, styles.field_name)}>
            <GenericNameField
              labelText={lastNameLabel}
              fieldName={QFF_LAST_NAME_KEY}
              onChange={onFieldChangeHandler}
              onBlur={onFieldBlur}
              value={fieldValues[QFF_LAST_NAME_KEY]}
              errorMessage={fieldError[QFF_LAST_NAME_KEY]}
              loading={isLoading}
              isRequired
            />
          </div>
          <div className={className(styles.field, styles.field_email)}>
            <EmailField
              labelText={emailLabel}
              fieldName={QFF_EMAIL_KEY}
              onChange={onFieldChangeHandler}
              onBlur={onFieldBlur}
              onFocus={clearEmailErrors}
              value={fieldValues[QFF_EMAIL_KEY]}
              errorMessage={fieldError[QFF_EMAIL_KEY]}
              loading={isLoading}
              isRequired
            />
          </div>
          <div className={className(styles.field, styles.field_reference)}>
            <GenericNameField
              labelText={referenceLabel}
              fieldName={QFF_REFERENCE_KEY}
              onChange={onFieldChangeHandler}
              onBlur={onFieldBlur}
              value={fieldValues[QFF_REFERENCE_KEY]}
              errorMessage={fieldError[QFF_REFERENCE_KEY]}
              loading={isLoading}
              isRequired
            />
          </div>
          <div className={className(styles.field, styles.field_qff)}>
            <QantasFrequentFlyerNumberField
              labelText={qffLabel}
              fieldName={QFF_NUMBER_KEY}
              onChange={onFieldChangeHandler}
              onBlur={onFieldBlur}
              value={fieldValues[QFF_NUMBER_KEY]}
              errorMessage={fieldError[QFF_NUMBER_KEY]}
              loading={isLoading}
              isRequired
            />
          </div>
          <div className={styles.field_submit}>
            <BrandedButton
              labelText={submitLabel}
              iconName="arrowRight"
              loading={isLoading}
              fitContent
            />
          </div>
          {termsConditionsElement}
          {responseMessageElement}
        </fieldset>
        <div
          className={styles.success_container}
          id={QFF_SUCCESS_CONTAINER_ID}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: successText }}
        />
      </form>
    )
  }
}

QantasFrequentFlyerDetailed.propTypes = {
  qffReducer: PropTypes.shape({
    isLoading: PropTypes.bool,
    success: PropTypes.bool,
    message: PropTypes.string,
  }),
  fieldValues: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
  }),
  fieldError: PropTypes.object,
  firstNameLabel: PropTypes.string,
  lastNameLabel: PropTypes.string,
  emailLabel: PropTypes.string,
  referenceLabel: PropTypes.string,
  qffLabel: PropTypes.string,
  submitLabel: PropTypes.string,
  termsText: PropTypes.string,
  successText: PropTypes.string,
  isFormComplete: PropTypes.bool,

  onSubmit: PropTypes.func,
  onFieldChangeHandler: PropTypes.func,
  onFieldBlur: PropTypes.func,
  clearEmailErrors: PropTypes.func,
}

QantasFrequentFlyerDetailed.defaultProps = {
  qffReducer: {
    isLoading: false,
    success: false,
    message: '',
  },
  fieldValues: {},
  fieldError: {},
  firstNameLabel: 'Your First Name',
  lastNameLabel: 'Your Last Name',
  emailLabel: 'Your Email',
  referenceLabel: 'Your Kogan Internet Customer Reference',
  qffLabel: 'Your Qantas Frequent Flyer Number (only the digits)',
  submitLabel: 'Register Details',
  termsText: null,
  successText: null,
  isFormComplete: false,

  onSubmit: f => f,
  onFieldChangeHandler: f => f,
  onFieldBlur: f => f,
  clearEmailErrors: f => f,
}



// WEBPACK FOOTER //
// ./components/QantasFrequentFlyerDetailed/index.jsx